export type EntityIcon = {
  key: string;
  iconName: string;
};

export const entityIcons: EntityIcon[] = [
  { key: "officeBuilding", iconName: "ApartmentIcon" },
  { key: "business", iconName: "BusinessIcon" },
  { key: "storefront", iconName: "StorefrontIcon" },
  { key: "workplace", iconName: "HomeWorkIcon" },
  { key: "hospital", iconName: "LocalHospitalIcon" },
  { key: "school", iconName: "SchoolIcon" },
  { key: "library", iconName: "LocalLibraryIcon" },
  { key: "factory", iconName: "FactoryIcon" },
  { key: "warehouse", iconName: "WarehouseIcon" },
  { key: "cafe", iconName: "LocalCafeIcon" },
  { key: "restaurant", iconName: "RestaurantIcon" },
  { key: "groceryStore", iconName: "LocalGroceryStoreIcon" },
  { key: "museum", iconName: "MuseumIcon" },
  { key: "religious", iconName: "ChurchIcon" },
  { key: "police", iconName: "LocalPoliceIcon" },
  { key: "transport", iconName: "DirectionsBusIcon" },
  { key: "logistics", iconName: "AirportShuttleIcon" },
  { key: "bank", iconName: "AccountBalanceIcon" },
  { key: "nature", iconName: "NatureIcon" },
  { key: "ngo", iconName: "EmojiPeopleIcon" },
];
